import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { event } from 'jquery';
import { ThemeService } from '../../services/theme.service';
import { Router } from '@angular/router';
import { UtilService } from '../../services/util.service';
import { AuthentictionService } from '../../services/authentiction.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '../../services/message.service';
import { NgForm } from '@angular/forms';
import { LivestreamService } from '../../services/livestream.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { RefreshDbModalComponent } from '../../../Shared/modal/refreshdb-modal/refreshdb-modal.component';
import { MovieService } from '../../services/movie.service';
declare var $:any;
declare var bootstrap: any; // Bootstrap 5 global

@Component({
  selector: 'app-all-settings',
  templateUrl: './all-settings.component.html',
  styleUrls: ['./all-settings.component.css']
})
export class AllSettingsComponent implements OnInit {
  @Input() color: any
 @ViewChild('categoryModalRef') categoryModalRef!: ElementRef;
 @ViewChild('categoryModalRefs') categoryModalRefs!: ElementRef;
  modalInstance: any;
  settingType: string = 'user_account';
  listOfSettings = [
    { name: 'User A/C Info', value: 'user_account', icon: 'fa fa-user', selected: false },
    { name: 'Change Language', value: 'change_language', icon: 'fa fa-language', selected: false },
    { name: 'Change Color', value: 'color', selected: false }
  ]
  colorTheme = [{
    'color': 'black',
    selected: false
  },
  {
    'color': 'purple',
    selected: true
  },
  {
    'color': 'brown',
    selected: false
  }
  ];
  videoSourceType=[
    // {name:'HLS (.m3u)',source:'application/x-mpegURL',format:'.m3u'},
    {name:'HLS(.m3u8)',source:'application/x-mpegURL',format:'.m3u8'},
    {name:'MPEG(.ts)',source:'application/vnd.apple.mpegurl',format:'.ts'}
  ];
  settingData =[
    { name: "SETTING.PLAYLIST_INFO" },
    { name: "SETTING.CHANGE_LANG" },
    // { name: "SETTING.PARANT_CONT" },
    // { name: "SETTING.HIDE_CONT" },
    { name: "SETTING.STREAM_FORMAT"},
    {name: "SETTING.TIME_FORMAT"},
    // { name: "SETTING.RESET_DEVICE"},
    {name:"SETTING.REFRESH_DATA"},
    {name:"SETTING.PRIVACY_POLICY"},
    {name:"SETTING.TERMSOFUSE"}
  ];
  activeTranslatedSetting: string = '';
  types: 'password' | 'text' = 'password'; // For login
  registerPasswordType: 'password' | 'text' = 'password'; // For register - password
  confirmPasswordType: 'password' | 'text' = 'password'; // For register - confirm password
  registerUser: any = { currentPassword:'', password: '', confirmPassword: '' };
  deleteUser:any = {password:''}

  isLanguage:boolean=false;
  isUserData:boolean=true;
  isParental:boolean=false;
  isStreamFormat:boolean=false;
  timeFormat:boolean = false;
  manageAccount:boolean = false;
  isprivacy:boolean = false;
  isterms:boolean = false;
  isrefresh:boolean = false;
  translatedChangeLang:any;
  translatedUserProfile:any;
  translatedStreamFormat:any;
  translatedTimeFormat:any;
  translatedManageAccount:any;
  translatedPrivacy:any;
  translatedRefresh:any;
  translatedTerms:any;
  sourceType ='application/x-mpegURL';
  formatType ='.m3u8';
  isCheckboxChecked:boolean = true;
  themeColor: string = 'purple';
  Playlist_profile_id:any;
  multi_profile:boolean = false;
  isLocalPlaylist:boolean= false;
  localProfile:any;
  userData:any;
  isUser:boolean=false;
  playlistProfile:any;
  isProfile:boolean = false;
  selectedFormat: string = '24h';
  privacy:string ='';
  terms:string ='';

  constructor(private modalService: BsModalService,private liveService:LivestreamService,private movieService:MovieService,private messageService: MessageService,private themeService: ThemeService,private translate:TranslateService,private authService:AuthentictionService,private router:Router,private utilService:UtilService) {
    // this.color=localStorage.getItem('color')
    this.formatType = localStorage.getItem('formatType');
    
  }

  ngOnInit(): void {
     // Get raw data from localStorage
  const localProfileRaw = localStorage.getItem('localProfile');
  const userDataRaw = localStorage.getItem('userData');
  const profileRaw = localStorage.getItem('Profile');
  const timeFormat = localStorage.getItem('timeFormat');
  const privacy = localStorage.getItem('privacy');
  const terms = localStorage.getItem('terms');
  if(privacy !== " "){
    this.privacy = privacy;
  }
  if(terms !== " "){
    this.terms = terms;
  }
  if(timeFormat){
    this.selectedFormat = timeFormat;
  }

  // Safely handle userData
  if (userDataRaw !== null) {
    try {
      this.userData = JSON.parse(userDataRaw);
      this.isUser = true;
    } catch (error) {
      console.error('Invalid userData JSON:', error);
      this.userData = null;
      this.isUser = false;
    }
  } else {
    console.warn('userData key not found in localStorage');
    this.userData = null;
    this.isUser = false;
  }
  //safty for profile data
  if(profileRaw !== null){
    try{
      this.playlistProfile = JSON.parse(profileRaw);
      this.isProfile = true;
    }catch(error){
      this.playlistProfile = null;
      this.isProfile = false;
    }
  }else{
  this.playlistProfile = null;
      this.isProfile = false;
  }
  // Safely handle localProfile
  if (localProfileRaw !== null) {
    try {
      this.localProfile = JSON.parse(localProfileRaw);
      this.multi_profile = this.localProfile?.multiprofile === 'true';
    } catch (error) {
      console.error('Invalid localProfile JSON:', error);
      this.localProfile = null;
      this.multi_profile = false;
    }
  } else {
    console.warn('localProfile key not found in localStorage');
    this.localProfile = null;
    this.multi_profile = false;
  }

  console.log('Multi-profile enabled:', this.multi_profile);

    const islocalPlaylist = localStorage.getItem('isLocalPlaylist') || '';
    if(islocalPlaylist == 'true'){
      this.isLocalPlaylist = true;
    }else{
      this.isLocalPlaylist = false;
    }
    this.themeService.themeColorChanged.subscribe((color: string) => {
      this.themeColor = color;
    });
    
  

  // Also resolve other strings to compare inside isActiveSetting()
  this.translate.get([
    "SETTING.PLAYLIST_INFO",
  ]).subscribe((res: any) => {
    this.translatedUserProfile = res["SETTING.PLAYLIST_INFO"];
  });

    this.onChangeColor(event)
    this.listOfSettings.map((item, index) => {
      (index == 0) ? item.selected = true : item.selected = false;
    });
    
  }

  onChange(name:string){
      const lang = localStorage.getItem('language');
      console.log(lang,'language'); 
      this.translate.get('SETTING.CHANGE_LANG').subscribe((res: string) => {
        this.translatedChangeLang = res;
        
      });
  
      this.translate.get('SETTING.PLAYLIST_INFO').subscribe((res: string) => {
        this.translatedUserProfile = res;
      });

      this.translate.get('SETTING.STREAM_FORMAT').subscribe((res: string) => {
        this.translatedStreamFormat = res;
      });

      this.translate.get('SETTING.TIME_FORMAT').subscribe((res: string) => {
        this.translatedTimeFormat = res;
      })

      this.translate.get('SETTING.PRIVACY_POLICY').subscribe((res: string) => {
        this.translatedPrivacy = res;
      })

      this.translate.get('SETTING.TERMSOFUSE').subscribe((res:string) =>{
        this.translatedTerms = res;
      })
       
      
      this.translate.get('SETTING.REFRESH_DATA').subscribe((res: string) =>{
        this.translatedRefresh =res;
      })
    

    this.translate.get(name).subscribe((translatedName: string) => {
    console.log(translatedName,'translateName',this.translatedChangeLang);
      
    if(translatedName === this.translatedChangeLang){
      this.isLanguage = true;
      this.isUserData = false;
      this.isStreamFormat = false;
      this.timeFormat = false;
      this.manageAccount= false;
      // this.isprivacy = false;
      // this.isterms = false;
      this.isrefresh = false;

    }else if(translatedName === this.translatedUserProfile){
      this.isLanguage = false;
      this.isUserData = true;
      this.isStreamFormat =false;
      this.timeFormat = false;
      this.manageAccount= false;
      // this.isprivacy = false;
      // this.isterms = false;
      this.isrefresh = false;

    }else if(translatedName === this.translatedStreamFormat){
      this.isStreamFormat = true;
      this.isLanguage = false;
      this.isUserData = false;
      this.timeFormat = false;
      this.manageAccount= false;
      // this.isprivacy = false;
      // this.isterms = false;
      this.isrefresh = false;


    }else if(translatedName === this.translatedTimeFormat){
      this.timeFormat = true;
      this.isStreamFormat = false;
      this.isLanguage = false;
      this.isUserData = false;
      this.manageAccount= false;
      // this.isprivacy = false;
      // this.isterms = false;
      this.isrefresh = false;


    }else if(translatedName === this.translatedPrivacy){
      // this.timeFormat = false;
      // this.isStreamFormat = false;
      // this.isLanguage = false;
      // this.isUserData = false;
      // this.manageAccount= false;
      // this.isrefresh = false;
      // this.isterms = false;
      window.open(this.privacy,'_blank')
    }else if(translatedName === this.translatedTerms){
      // this.timeFormat = false;
      // this.isStreamFormat = false;
      // this.isLanguage = false;
      // this.isUserData = false;
      // this.manageAccount= false;
      // this.isrefresh = false;
      window.open(this.terms ? this.terms : this.privacy,'_blank')
    }
    else if(translatedName === this.translatedRefresh){
      this.manageAccount= false;
      this.timeFormat = false;
      this.isStreamFormat = false;
      this.isLanguage = false;
      this.isUserData = false;
      this.isrefresh = true;
    }
  })
}
onChanges(){
   this.manageAccount= true;
      this.timeFormat = false;
      this.isStreamFormat = false;
      this.isLanguage = false;
      this.isUserData = false;
      this.isrefresh = false;
}

isActiveSetting(settingName: string): boolean {
  // Translate the current setting name to check if it matches the active setting
  let isActive = false;
  this.translate.get(settingName).subscribe((translatedName: string) => {
    if (translatedName === this.translatedChangeLang && this.isLanguage) {
      isActive = true;
    } else if (translatedName === this.translatedUserProfile && this.isUserData) {
      isActive = true;
    } else if (translatedName === this.translatedStreamFormat && this.isStreamFormat) {
      isActive = true;
    } else if(translatedName === this.translatedTimeFormat && this.timeFormat){
      isActive = true;
    }else if(translatedName === this.translatedRefresh && this.isrefresh){
      isActive = true;
    }
  });
  return isActive;
}

  changeSettingType(type: string, id) {
    this.settingType = type;
    this.listOfSettings.map((item, index) => {
      (index == id) ? item.selected = true : item.selected = false;
    });
  }

  onChangeColor(event: any) {
    if (event.target.value) {
      event.target.style.background = event.target.value;
      this.color = event.target.value;
      // localStorage.setItem('color', event.target.value);

      // let sidebar = document.querySelector(".sidebar");
      // color.style.background(".active")
      // sidebar.classList.toggle("active");
    }
  }

  changeColor(color: string): void {
    this.themeService.setSelectedColor(color);
  }
  changeVideoFormat(format){
    // this.sourceType=format.target.value;
    // this.sourceType = this.isVideoFormatMPEG() ? 'application/x-mpegURL' : 'application/vnd.apple.mpegurl';
    // localStorage.setItem('sourceType',this.sourceType)
    // this.sourceType = localStorage.getItem('formatType');
    this.formatType=format.target.value;
    localStorage.setItem('formatType',this.formatType)
    this.formatType = localStorage.getItem('formatType');
    this.formatType = this.isVideoFormatMPEG() ? '.m3u8' : '.ts';
  }

  switchProfile(){
    const islocalPlaylist = localStorage.getItem('isLocalPlaylist') || '';
    if(this.authService.isLogin() == false && islocalPlaylist == 'true'){
    // this.utilService.switchPlaylist();
    this.router.navigate(['/playlist']);
    }else{
      const profile = JSON.parse(localStorage.getItem('Profile'));
      if(profile){
        this.Playlist_profile_id = profile.playlist_id;
      } 
      console.log(this.utilService.getFullUrl(),this.utilService.getFullPassword(),this.utilService.getFullUsername());

      this.router.navigate(['/profile'],{state:{id:this.Playlist_profile_id,username:this.utilService.getFullUsername(),password:this.utilService.getFullPassword(),dns:this.utilService.getFullUrl()}});
    }
  }
  switchPlaylist(){
    localStorage.removeItem('Profile');
    // this.utilService.switchPlaylist();
    this.router.navigate(['/playlist']);
  }

  switchPlaylistLocal(){
    // this.utilService.switchPlaylist();
    localStorage.removeItem('localProfile');
    this.router.navigate(['/playlist']);
  }

  logoutPlaylist(){
     const logoutTranslation = this.translate.instant('HOME.LOGOUT');
        const confirmationTranslation = this.translate.instant('HOME.LOGOUT_CONFIRMATION');
        const yes = this.translate.instant('HOME.YES')
        const no = this.translate.instant('HOME.NO')
        // this.messageService.confirm('LogOut!', 'Are you sure you want to Log Out?')
        const islocalPlaylist = localStorage.getItem('isLocalPlaylist') || '';
        const currentPlaylistId = localStorage.getItem('playlist_id'); // Assume this holds the current playlist ID
        this.messageService.confirm(logoutTranslation, confirmationTranslation)
            .subscribe((answer) => {
                if (answer === yes) {
                
                  if( islocalPlaylist == 'true'){
                  
                     // Remove matched playlist from xstream_playlists
                  const storedPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
                  console.log(storedPlaylists);
                  localStorage.removeItem('playlist');
                  const updatedPlaylists = storedPlaylists.filter((item: any) => item.id != currentPlaylistId);
                  localStorage.setItem('xstream_playlists', JSON.stringify(updatedPlaylists));
                  localStorage.setItem('multiprofile','false')
                  localStorage.removeItem('playlist_id');
                  localStorage.removeItem('localProfile');
                  // this.utilService.switchPlaylist();
                  this.router.navigate(['/playlist']);
                  }
                
                }else{
              
              
                }
              })



  }

  logout(){
      this.utilService.logout();
  }

  deleteAccount(){
         const logoutTranslation = this.translate.instant('HOME.DELETE');
        const confirmationTranslation = this.translate.instant('HOME.DELETE_CONFIRMATION');
        const yes = this.translate.instant('HOME.YES')
        const no = this.translate.instant('HOME.NO')
        // this.messageService.confirm('LogOut!', 'Are you sure you want to Log Out?')
        this.messageService.confirm(logoutTranslation, confirmationTranslation)
            .subscribe((answer) => {
                if (answer === yes) {

               
      }})
  }
  onTimeFormatChange(event:Event){
    console.log( this.selectedFormat);
    localStorage.setItem('timeFormat', this.selectedFormat);
    this.utilService.showSuccess("Time Format updated Successfully.");
    // if(this.selectedFormat === '12h'){
    // }else{
    // }
  }
  async refreshMovies(){
    await this.movieService.loadMoviesdb(true); 

  }

 refreshContent(mode: 'livetv' | 'movies' | 'series' | 'all') {
  const playlistItem = JSON.parse(localStorage.getItem('playlist') || '{}');

  const bsRef: BsModalRef = this.modalService.show(RefreshDbModalComponent, {
    backdrop: 'static',
    keyboard: false,
    class: 'modal-fullscreen',
    initialState: {
      playlistItem,
      mode  // 👈 can be 'livetv', 'movies', 'series', or 'all'
    }
  });

  bsRef.content.onClose.subscribe((result: string) => {
    if (result === 'yes') {
      console.log(`${mode.toUpperCase()} refreshed successfully`);
    } else {
      console.warn(`Refresh for ${mode} failed or cancelled`);
    }
  });
}


  async refreshLivetv(){
  await    console.log('clicked');
      
      await this.liveService.loadLivetvdbCategories(true)
      await this.liveService.loadLivetvdb(true)
  }

  refreshAll(){
    
  }
 
   onRegisterSubmit(form: NgForm) {
        if (form.invalid) {
          // Mark all controls as touched to show validation messages
          Object.keys(form.controls).forEach(field => {
            const control = form.controls[field];
            control.markAsTouched({ onlySelf: true });
          });
        return; // stop execution here if form is invalid
    }
  // ✅ Check if passwords match
    if (this.registerUser.password !== this.registerUser.confirmPassword) {
      form.controls['confirmPassword'].setErrors({ mismatch: true });
      return;
    } else {
      form.controls['confirmPassword'].setErrors(null); // Clear previous error
    }
    // Proceed with form submission if valid
    // this.isLoading = false;
    this.utilService.hideSpinner();
  
    const param = {
      currentPassword:this.registerUser.currentPassword,
      password: this.registerUser.password
      // confirmPwd: this.registerUser.confirmPassword
    };
    console.log(param);
    this.authService.changePassword(param).subscribe((res:any)=>{
      if(res.status == "success"){
        this.utilService.showSuccess(res.message)
        console.log(res);
        if (this.modalInstance) {
        this.modalInstance.hide();
        }
        form.reset()
      }
      
    },err =>{
      console.log(err.error);
      if(err?.error?.errors?.new_password[0] == "The new password and current password must be different."){
        this.utilService.showErrorToast(err.error.errors.new_password[0])
      }else if(err.error){
        this.utilService.showErrorToast(err.error.message)
      }
    })
  }

  ondeleteSubmit(form:NgForm){
      if (form.invalid) {
          // Mark all controls as touched to show validation messages
          Object.keys(form.controls).forEach(field => {
            const control = form.controls[field];
            control.markAsTouched({ onlySelf: true });
          });
        return; // stop execution here if form is invalid
    }
    const param = {
    password:this.deleteUser.password,
    email:this.userData.email
    };
    console.log(param);
    
    this.authService.login(param).subscribe(res=>{
      if(res){
           this.authService.deteteAccount().subscribe((res:any)=>{
            if(res){
                    this.utilService.cleardb();
                    this.utilService.clearCookieStorage();
                    this.utilService.removeFullModeStorage();
                    // localStorage.removeItem('progressComplete');
                    localStorage.removeItem('Profile')
                    localStorage.removeItem('mtoken')
                    localStorage.removeItem('userData')
                    localStorage.removeItem('purple_playlist')
                    localStorage.removeItem('playlist')
                    setTimeout(() => {
                    // window.location.reload();
                    this.router.navigate(['/playlist']);
                    }, 500);
                  }
                    if (this.modalInstance) {
                    this.modalInstance.hide();
                    }
          })
      }
    },err =>{
      this.utilService.showErrorToast(err.error.message)
    })
  
  }
  openModal() {
    this.modalInstance = new bootstrap.Modal(this.categoryModalRef.nativeElement);
    this.modalInstance.show();
  }

  cancel() {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }

  openModals(){
     this.modalInstance = new bootstrap.Modal(this.categoryModalRefs.nativeElement);
     this.modalInstance.show();
  }
  cancels() {
    if (this.modalInstance) {
      this.modalInstance.hide();
      this.deleteUser.password =''
    }
  }

 hideShowPassword(): void {
    this.types = this.types === 'password' ? 'text' : 'password';
    console.log(this.types)
    
  }
  
  hideShowRegisterPassword(): void {
    this.registerPasswordType = this.registerPasswordType === 'password' ? 'text' : 'password';
    console.log(typeof(this.registerPasswordType));
    
  }
  
  hideShowConfirmPassword(): void {
    this.confirmPasswordType = this.confirmPasswordType === 'password' ? 'text' : 'password';
    console.log(this.confirmPasswordType);
    
  }

  isVideoFormatMPEG(): boolean {
    // Replace with the actual logic to determine if the video format is MPEG
    return false;
  }

  getVideoType(): string {
    return this.isVideoFormatMPEG() ? '.m3u8' : '.ts';
  }

  login(){
    this.router.navigate(['/login']);
  }
}
